/**
 * M365 accounts permitted to import historical order data on the Historical
 * Data screen. Sourced from the IG OPC employee roster; HRIS-Payroll access
 * is governed separately (HR / CEO / owner only) and is unrelated to this list.
 */
export const HISTORICAL_IMPORT_ALLOWED_USERS: string[] = [
  "inhousesewer1@intalgarmentsopc.onmicrosoft.com",
  "deliveryassembly@intalgarmentsopc.onmicrosoft.com",
  "packaginga@intalgarmentsopc.onmicrosoft.com",
  "cutting1@intalgarmentsopc.onmicrosoft.com",
  "prepassembly@intalgarmentsopc.onmicrosoft.com",
  "cutting2@intalgarmentsopc.onmicrosoft.com",
  "inhousesewer2@intalgarmentsopc.onmicrosoft.com",
  "inhousesewer3@intalgarmentsopc.onmicrosoft.com",
  "hrandpurchasing@intalgarmentsopc.onmicrosoft.com",
  "cutting3@intalgarmentsopc.onmicrosoft.com",
  "embroidery@intalgarmentsopc.onmicrosoft.com",
  "facility@intalgarmentsopc.onmicrosoft.com",
  "qc@intalgarmentsopc.onmicrosoft.com",
  "contractorslead@intalgarmentsopc.onmicrosoft.com",
  "managingowner@intalgarmentsopc.onmicrosoft.com",
  "mikko@intalgarmentsopc.onmicrosoft.com",
  "qc1@intalgarmentsopc.onmicrosoft.com",
  "customersales1@intalgarmentsopc.onmicrosoft.com",
  "inhousesewer6@intalgarmentsopc.onmicrosoft.com",
  "inventory@intalgarmentsopc.onmicrosoft.com",
  "operations02@intalgarmentsopc.onmicrosoft.com",
  "qc2@intalgarmentsopc.onmicrosoft.com",
  "procurementdespatch@intalgarmentsopc.onmicrosoft.com",
  "fulfillmentandinventoryandpackaging@intalgarmentsopc.onmicrosoft.com",
  "cutting@intalgarmentsopc.onmicrosoft.com",
  "cutting4@intalgarmentsopc.onmicrosoft.com",
  "operations@intalgarmentsopc.onmicrosoft.com",
  "inhousesewer4@intalgarmentsopc.onmicrosoft.com",
  "qc3@intalgarmentsopc.onmicrosoft.com",
  "cutting5@intalgarmentsopc.onmicrosoft.com",
  "financeandsupport@intalgarmentsopc.onmicrosoft.com",
  "inhousesewer5@intalgarmentsopc.onmicrosoft.com",
  "cuttingsection@intalgarmentsopc.onmicrosoft.com",
  "salesmarketing1@intalgarmentsopc.onmicrosoft.com",
  "hrmanager@intalgarmentsopc.onmicrosoft.com",
  "crmsup@intalgarmentsopc.onmicrosoft.com",
  "assembly2@intalgarmentsopc.onmicrosoft.com",
  "inhousesewer09@intalgarmentsopc.onmicrosoft.com",
  "fulfillmentandlogistics@intalgarmentsopc.onmicrosoft.com",
  "finance1@intalgarmentsopc.onmicrosoft.com",
  "projectbase@intalgarmentsopc.onmicrosoft.com",
  "accountsadmin@intalgarmentsopc.onmicrosoft.com",
  "consultant@intalgarmentsopc.onmicrosoft.com"
];
